import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { CreativeFilingFieldsProps } from "@/types/creative-library";
export function CreativeFilingFields({
  brands,
  products,
  brandToken,
  productToken,
  disabled,
  testIdPrefix,
  onChange,
  hideProduct,
}: CreativeFilingFieldsProps) {
  const { t } = useTranslation("app");
  const compatible = products.filter(
    (product) => product.brandToken === brandToken,
  );
  return (
    <div className={hideProduct ? "grid gap-4" : "grid gap-4 sm:grid-cols-2"}>
      <div className="flex flex-col gap-2">
        <Label>{t("creativeLibrary.brand")}</Label>
        <Select
          value={brandToken}
          disabled={disabled}
          onValueChange={(value) =>
            onChange(
              value,
              products.find((product) => product.token === productToken)
                ?.brandToken === value
                ? productToken
                : "none",
            )
          }
        >
          <SelectTrigger
            aria-label={t("creativeLibrary.brand")}
            data-testid={`${testIdPrefix}-brand`}
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">{t("creativeLibrary.noBrand")}</SelectItem>
            {brands.map((brand) => (
              <SelectItem key={brand.token} value={brand.token}>
                {brand.name}
              </SelectItem>
            ))}
            {brandToken !== "none" &&
              !brands.some((brand) => brand.token === brandToken) && (
                <SelectItem value={brandToken} disabled>
                  {t("creativeLibrary.unavailableSelection")}
                </SelectItem>
              )}
          </SelectContent>
        </Select>
      </div>
      {!hideProduct && (
        <div className="flex flex-col gap-2">
          <Label>{t("creativeLibrary.product")}</Label>
          <Select
            value={productToken}
            disabled={disabled || brandToken === "none"}
            onValueChange={(value) => onChange(brandToken, value)}
          >
            <SelectTrigger
              aria-label={t("creativeLibrary.product")}
              data-testid={`${testIdPrefix}-product`}
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">
                {t("creativeLibrary.noProduct")}
              </SelectItem>
              {compatible.map((product) => (
                <SelectItem key={product.token} value={product.token}>
                  {product.name}
                </SelectItem>
              ))}
              {productToken !== "none" &&
                !compatible.some(
                  (product) => product.token === productToken,
                ) && (
                  <SelectItem value={productToken} disabled>
                    {t("creativeLibrary.unavailableSelection")}
                  </SelectItem>
                )}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
